// extracted by mini-css-extract-plugin
export default {"deposit":"Summary_deposit__6Gu5t","withdrawal":"Summary_withdrawal__ldxO0","netDifference":"Summary_netDifference__Zs6tK"};